import z from "zod";

/**
 * ReportComprasSchema
 */

export const ReportComprasSchema = z.object({
  centroCustos: z.array(z.number()).nullable().default(null),
  titulo: z.string().nullable().default(null),
  ordemCompras: z.array(z.number()).nullable().default(null),
  subcontas: z.array(z.number()).nullable().default(null),
  fornecedores: z.array(z.number()).nullable().default(null),
  dataOC: z.array(z.coerce.date().nullable()).nullable().default(null),
  produtoServicos: z.array(z.number()).nullable().default(null),
  dataPago: z.array(z.coerce.date().nullable()).nullable().default(null),
  statusOC: z.array(z.number()).nullable().default(null),
});

/**
 * ReportComprasForm
 */

export type ReportComprasForm = z.infer<typeof ReportComprasSchema>;